import { Box, MenuItem, MenuList, Popover, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';

import { QUICK_ACTION_ITEMS } from '@web/constants/QuickAction';
import type { QuickAction } from '@web/constants/QuickAction';

type Props = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onAction: (id: QuickAction) => void;
};

export const QuickActionsDropdown: FC<Props> = ({ anchorEl, open, onClose, onAction }) => {
  const theme = useTheme();
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      disableAutoFocus
      disableEnforceFocus
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            borderRadius: '8px',
            border: `1px solid ${theme.palette.SlabGray.Stroke}`,
            boxShadow: '0 3px 10px rgba(96,108,128,0.06)',
            width: '204px',
            py: 0.5,
          },
        },
      }}
    >
      <MenuList disablePadding>
        {QUICK_ACTION_ITEMS.map(({ id, label, Icon, shortcutKey }) => (
          <MenuItem
            key={id}
            onClick={() => {
              onAction(id);
              onClose();
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px',
              gap: '8px',
              '&:hover': {
                backgroundColor: theme.palette.SlabGray.Table,
              },
            }}
          >
            <Icon size={24} variant='TwoTone' color={theme.palette.SlabGray[600]} />
            <Typography
              sx={{
                flex: 1,
                fontSize: '16px',
                lineHeight: '24px',
                color: theme.palette.SlabGray[900],
              }}
            >
              {label}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '20px',
                height: '20px',
                borderRadius: '4px',
                backgroundColor: theme.palette.SlabGray.Table,
                marginLeft: 'auto',
              }}
            >
              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: theme.palette.SlabGray[500],
                }}
              >
                {shortcutKey}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </MenuList>
    </Popover>
  );
};
